import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Login.css';

const Register = () => {
    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [needsVerification, setNeedsVerification] = useState(false);
    const navigate = useNavigate();
    const { signUp } = useAuth();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        if (formData.password.length < 6) {
            setError('Password must be at least 6 characters.');
            return;
        }

        setLoading(true);

        try {
            const data = await signUp(formData.email, formData.password, formData.full_name);

            // Check if email verification is needed
            if (!data.session) {
                setNeedsVerification(true);
                setSuccess(true);
            } else {
                setSuccess(true);
                setTimeout(() => navigate('/login'), 2000);
            }

        } catch (err) {
            console.error('Registration error:', err);
            setError(err.message || 'Registration failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // Show verification message
    if (success && needsVerification) {
        return (
            <div className="login-page">
                <div className="login-container">
                    <div className="login-card" style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '60px', marginBottom: '20px' }}>&#128231;</div>
                        <h2 style={{ color: '#155724', marginBottom: '15px' }}>Verify Your Email</h2>
                        <p style={{ color: '#666', marginBottom: '20px' }}>
                            We've sent a verification link to:<br/>
                            <strong style={{ color: '#333' }}>{formData.email}</strong>
                        </p>
                        <p style={{ color: '#888', fontSize: '14px', marginBottom: '25px' }}>
                            Please check your inbox and click the verification link to activate your account.
                        </p>
                        <button
                            onClick={() => navigate('/login')}
                            className="login-submit-btn"
                            style={{ width: '100%' }}
                        >
                            Go to Login
                        </button>
                        <p style={{ marginTop: '20px', fontSize: '13px', color: '#999' }}>
                            Didn't receive email? Check your spam folder.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">

                    <div className="login-header-section">
                        <h2>Create Account</h2>
                        <p>Register to get started</p>
                    </div>

                    {success && (
                        <div style={{
                            background: '#d4edda',
                            color: '#155724',
                            border: '1px solid #c3e6cb',
                            borderRadius: '8px',
                            padding: '10px 14px',
                            marginBottom: '16px',
                            fontSize: '14px'
                        }}>
                            Registration successful! Redirecting to login...
                        </div>
                    )}

                    {error && (
                        <div style={{
                            background: '#f8d7da',
                            color: '#721c24',
                            border: '1px solid #f5c6cb',
                            borderRadius: '8px',
                            padding: '10px 14px',
                            marginBottom: '16px',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="login-form-global">

                        <div className="form-group">
                            <label>Full Name</label>
                            <input
                                type="text"
                                name="full_name"
                                value={formData.full_name}
                                onChange={handleChange}
                                placeholder="John Doe"
                                required
                                autoComplete="name"
                            />
                        </div>

                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="name@company.com"
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Min. 6 characters"
                                required
                                autoComplete="new-password"
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirm Password</label>
                            <input
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Re-enter password"
                                required
                                autoComplete="new-password"
                            />
                        </div>

                        <button type="submit" className="login-submit-btn" disabled={loading || success}>
                            {loading ? 'Creating account...' : 'Create Account'}
                        </button>
                    </form>

                    <div className="login-footer-section">
                        <p>
                            Already have an account?
                            <button
                                type="button"
                                className="toggle-btn"
                                onClick={() => navigate('/login')}
                            >
                                Log In
                            </button>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Register;